
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FAQCategory from "@/components/faqs/FAQCategory";
import WhyChooseUs from "@/components/shared/WhyChooseUs";
import { 
  generalFaqs, 
  whyUseFaqs, 
  platformFaqs, 
  keywordsFaqs, 
  implementationFaqs, 
  supportFaqs 
} from "@/components/faqs/FAQData";

const FAQs = () => {
  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | Upfixe Ads</title>
        <meta name="description" content="Find answers to common questions about Upfixe Ads, our AI-powered Google Ads automation platform." />
        <meta name="keywords" content="FAQ, Google Ads help, Upfixe questions, Google Ads automation help" />
        <meta property="og:title" content="Frequently Asked Questions | Upfixe Ads" />
        <meta property="og:description" content="Find answers to common questions about Upfixe Ads, our AI-powered Google Ads automation platform." />
        <link rel="canonical" href="https://upfixe.com/faqs" />
      </Helmet>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">
          <section className="bg-gradient-to-b from-slate-50 to-white py-12 md:py-24">
            <div className="container px-4 md:px-6">
              <div className="mx-auto max-w-4xl text-center mb-8 md:mb-12">
                <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
                  Frequently Asked Questions
                </h1>
                <p className="mt-4 text-muted-foreground md:text-xl">
                  Find answers to the most common questions about Upfixe Ads.
                </p>
                
                {/* Added WhyChooseUs component */}
                <div className="mt-8">
                  <WhyChooseUs className="justify-center" />
                </div>
              </div>
              
              <div className="mx-auto max-w-4xl">
                <Tabs defaultValue="why-us" className="mb-12">
                  <TabsList className="grid w-full grid-cols-2 md:grid-cols-6 mb-6">
                    <TabsTrigger value="why-us">Why Use Us?</TabsTrigger>
                    <TabsTrigger value="general">General</TabsTrigger>
                    <TabsTrigger value="how-it-works">How It Works</TabsTrigger>
                    <TabsTrigger value="keywords">Keywords & Ads</TabsTrigger>
                    <TabsTrigger value="implementation">Implementation</TabsTrigger>
                    <TabsTrigger value="support">Support</TabsTrigger>
                  </TabsList>
                  
                  <TabsContent value="why-us">
                    <FAQCategory faqs={whyUseFaqs} categoryId="why-us" />
                  </TabsContent>
                  
                  <TabsContent value="general">
                    <FAQCategory faqs={generalFaqs} categoryId="general" />
                  </TabsContent>
                  
                  <TabsContent value="how-it-works">
                    <FAQCategory faqs={platformFaqs} categoryId="platform" />
                  </TabsContent>
                  
                  <TabsContent value="keywords">
                    <FAQCategory faqs={keywordsFaqs} categoryId="keywords" />
                  </TabsContent>
                  
                  <TabsContent value="implementation">
                    <FAQCategory faqs={implementationFaqs} categoryId="implementation" />
                  </TabsContent>
                  
                  <TabsContent value="support">
                    <FAQCategory faqs={supportFaqs} categoryId="support" />
                  </TabsContent>
                </Tabs>
              </div>
              
              <div className="mt-12 text-center">
                <p className="text-muted-foreground mb-4">
                  Still have questions? We're here to help.
                </p>
                <a
                  href="/contact"
                  className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-8 text-sm font-medium text-white shadow transition-colors hover:bg-primary/90"
                >
                  Contact Support
                </a>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default FAQs;
